import React, {Component}   from 'react';
import {
  Modal as ModalB, Button
}                           from 'react-bootstrap';

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';

import {NAVIGATION}         from 'actions/const';

class Modal extends Component {
  render() {
    let {
      showModal,
      isLoggingOut
    } = this.props.navigation;

    let {
      setValue
    } = this.props.actions;

    return (
      <ModalB show={showModal}
        onHide={() => {
          if (!isLoggingOut) {
            setValue(NAVIGATION,'showModal', false);
          }
        }}>
        <ModalB.Header closeButton>
          <ModalB.Title>
            {this.props.children[0]}
          </ModalB.Title>
        </ModalB.Header>
        <ModalB.Body>
          {this.props.children[1]}
        </ModalB.Body>
        <ModalB.Footer>
          {this.props.children[2]}
        </ModalB.Footer>
      </ModalB>
    );
  }
}

function mapStateToProps(state) {
	var {navigation} = state;
	const props = {
		navigation
	};
	return props;
}

function mapDispatchToProps(dispatch) {
	const actions = {
		setValue: generics.setValue
	};
	const actionMap = {
		actions: bindActionCreators(actions, dispatch)
	};
	return actionMap;
}
export default connect(mapStateToProps, mapDispatchToProps)(Modal);



// WEBPACK FOOTER //
// ./components/Navigation/Modal.js